import React from 'react';
import { observer } from "mobx-react";
import { observable } from "mobx";
import NavModal from '../NavModal'

export default @observer class LoadHTMLModal extends NavModal {

  @observable text = "";

  constructor(props) {
    super(props, 'Load your HTML')
  }

  getHTML() {
    return this.getChild(0).value
  }

  onRender() {
    return (
      <textarea style={{
        position: 'relative',
        width: '80%',
        height: '200px',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, 20px)',
        resize: 'none',
        background: 'rgba(46, 52, 64, .2)',
        color: 'white'
      }} resize='none' placeholder="Paste your html code here and we'll do the rest !" />
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/ui/nav/modals/LoadHTMLModal.js